export default "__VITE_ASSET__56oDTj$$__"